window.Favorites = (function () {
    var dom, count;

    var init = function () {
        dom = {
            live: $('#fav_count-live'),
            prematch: $('#fav_count-prematch')
        };
        count = {
            live: parseInt(dom.live.html()) || 0,
            prematch: parseInt(dom.prematch.html()) || 0
        };

        update().all();
    };

    var update = function () {
        function isAlone() {
            //(count.live < 1) ? dom.prematch.addClass('m-alone') : dom.prematch.removeClass('m-alone');
            //(count.prematch < 1) ? dom.live.addClass('m-alone') : dom.live.removeClass('m-alone');
            if (count.live < 1 && count.prematch < 1) {
                dom.live.addClass('m-invisible');
                dom.prematch.addClass('m-invisible');
            } else {
                dom.live.removeClass('m-invisible');
                dom.prematch.removeClass('m-invisible');
            }
        }
        function live() {
            //(count.live < 1) ? dom.live.addClass('m-invisible') : dom.live.removeClass('m-invisible').html(count.live);
            dom.live.html(count.live);
            isAlone();
        }
        function prematch() {
            //(count.prematch < 1) ? dom.prematch.addClass('m-invisible') : dom.prematch.removeClass('m-invisible').html(count.prematch);
            dom.prematch.html(count.prematch);
            isAlone();
        }
        return {
            live: live,
            prematch: prematch,
			all: function () {
				live();
				prematch();
			}
        }
    };

    var decFavCount = function (isLive) {
        if (isLive) {
            count.live = (count.live <= 0) ? 0 : count.live - 1;
            update().live();
        }
        else {
            count.prematch = (count.prematch <= 0) ? 0 : count.prematch - 1;
            update().prematch();
        }
    };

    var incFavCount = function (isLive) {
        var domNode;
        if (isLive) {
            count.live++;
            update().live();
            domNode = dom.live;
        }
        else {
            count.prematch++;
            update().prematch();
            domNode = dom.prematch;
        }
        domNode.addClass('jump');
		setTimeout(function () { domNode.removeClass('jump') }, 400);
        //domNode.one('animationend', () => domNode.removeClass('jump'));
    };



    return {
        init: init,
        dec: decFavCount,
        inc: incFavCount
    }
}());